import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Card, CardBody, CardHeader,
} from "reactstrap";
import { api } from "../../../../api";
import Cookies from "js-cookie";
import Tippy from '@tippyjs/react';

const Employee1 = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [entriesToShow, setEntriesToShow] = useState(10);
  const [dataToShow, setDataToShow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [allData, setAllData] = useState([]);
  const [project, setProject] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedProject, setSelectedProject] = useState('Select Project'); // 1. Add state

  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);
  const toggleModal = () => setModalOpen(prevState => !prevState);

  const emp_id = Cookies.get("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        const response = await api.get(
          `viewProjectDetails.php?g_m_id=${emp_id}&company_id=${company_id}`
        );
        setProject(Array.isArray(response.data) ? response.data : []);
        
        // Fetch employees based on selected project
        let employeeResponse;
        if (selectedProject !== 'All Projects' && selectedProject !== 'Select Project') {
          // Fetch employees for specific project
          employeeResponse = await api.get(
            `employeesView.php?project_general_id=${emp_id}&company_id=${company_id}&filter_by_project=${encodeURIComponent(selectedProject)}`
          );
        } else {
          // Fetch all employees
          employeeResponse = await api.get(
            `employeesView.php?project_general_id=${emp_id}&company_id=${company_id}`
          );
        }
        
        setAllData(Array.isArray(employeeResponse.data) ? employeeResponse.data : []);
        console.log('All employees data:', employeeResponse.data);
        console.log('Sample employee structure:', employeeResponse.data[0]);
        console.log('Employee fields:', employeeResponse.data[0] ? Object.keys(employeeResponse.data[0]) : 'No data');
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setAllData([]); // fallback to empty array on error
      }
    };
    fetchData();
  }, [emp_id, selectedProject]);

  useEffect(() => {
    if (!Array.isArray(allData)) {
      setFilteredEmployees([]);
      return;
    }
    let filtered = allData;
    
    // Apply search filter only (project filtering is now handled by the server)
    const search = searchQuery.toLowerCase();
    filtered = filtered.filter(employee => {
      return (
        (employee.emp_id && employee.emp_id.toString().toLowerCase().includes(search)) ||
        (employee.emp_name && employee.emp_name.toLowerCase().includes(search)) ||
        (employee.role && employee.role.toLowerCase().includes(search)) ||
        (employee.address && employee.address.toLowerCase().includes(search)) ||
        (employee.phoneno && employee.phoneno.toString().toLowerCase().includes(search))
      );
    });
    
    setFilteredEmployees(filtered);
  }, [searchQuery, allData]);

  const handleEmployeeClick = (employee) => {
    setSelectedEmployee(employee);
    toggleModal();
  };

  useEffect(() => {
    setDataToShow(filteredEmployees.slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow));
  }, [entriesToShow, currentPage, filteredEmployees]);

  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(Number(value));
    setCurrentPage(1);
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < Math.ceil(filteredEmployees.length / entriesToShow)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  // Add helper for image path
  const getImagePath = (imageName) => {
    if (!imageName) return '/images/default-profile.png';
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return `/dashboard/images/${imageName}`;
    }
    return `/images/${imageName}`;
  };

  const handleProjectSelection = async (p_id, p_name) => {
    setSelectedProject(p_name);
    setSearchQuery(''); // Reset search query on project change
    setCurrentPage(1); // Reset to first page when project changes
    
    console.log(`Selected project: ${p_name} with ID: ${p_id}`);
  };

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className='mb-5'>
            <Col className="order-xl-2 mb-5 mb-xl-0 text-left ">
              <h1>Employee Details</h1>
            </Col>
            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex">
              <Form className="navbar-search  form-inline mr-3 d-none d-md-flex ml-lg-auto">
                <FormGroup className="mb-0">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-search" style={{color: 'black'}}/>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Search Employee Role"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
              </Form>
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle caret>
                  {selectedProject}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    onClick={async () => {
                      setSelectedProject("All Projects");
                      setSearchQuery(''); // Reset search query on All Projects
                      setCurrentPage(1); // Reset to first page
                    }}
                  >
                    All Projects
                  </DropdownItem>
                  {Array.isArray(project) ? (
                    project.map((project) => (
                      <DropdownItem
                        key={project.p_id}
                        onClick={() =>
                          handleProjectSelection(project.p_id, project.p_name)
                        }
                      >
                        {project.p_name}
                      </DropdownItem>
                    ))
                  ) : (
                    <DropdownItem>No Projects Found</DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row>
            <Col className="mb-5 mb-xl-0" xl="12" style={{ marginTop: "-20px" }}>
              <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff',borderRadius: '15px'}}>
                <CardBody>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">Employee List</h3>
                      </div>
                      <div className="col text-right">
                        <Dropdown isOpen={projectDropdownOpen} toggle={toggleProjectDropdown}>
                          <DropdownToggle caret>
                            Show Entries: {entriesToShow}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                            <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                            <DropdownItem onClick={() => handleEntriesChange(50)}>50</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </Row>
                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th>Emp ID</th>
                        <th>Profile</th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Location</th>
                        <th>Project(s)</th>
                        <th>View More</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataToShow.length === 0 ? (
                        <tr>
                          <td colSpan={7} style={{ color: 'black', fontWeight: 'bold', textAlign: 'center' }}>
                            No employee found
                          </td>
                        </tr>
                      ) : (
                        dataToShow.map((item, index) => (
                          <tr key={index}>
                            <td>{item.emp_id}</td>
                            <td>
                              <img
                                alt="...Image Not Found"
                                className="rounded-circle"
                                src={getImagePath(item.profile_image)}
                                style={{ height: 30, width: 30 }}
                                onError={e => { e.target.onerror = null; e.target.src = '/images/default-profile.png'; }}
                              />
                            </td>
                            <td>{item.emp_name}</td>
                            <td>{item.role}</td>
                            <td>{item.address}</td>
                            <td>
                              {selectedProject === 'All Projects' || selectedProject === 'Select Project' 
                                ? (item.project_names ? item.project_names.split(',').join(', ') : 'N/A')
                                : (item.p_name || 'N/A')
                              }
                            </td>
                            <td style={{fontSize: '20px'}}>
                              <a href="#pablo" onClick={() => handleEmployeeClick(item)}>
                              <Tippy content="View Employee Details"> 
                                <i className='fa fa-eye'></i>
                              </Tippy>
                              </a>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  <nav className='mt-3'>
                    <ul className='pagination justify-content-center'>
                      <li className='page-item'>
                        <a href='#' className='page-link text-primary' onClick={prePage}>Prev</a>
                      </li>
                      {[currentPage - 1, currentPage, currentPage + 1].map((pageNumber) => {
                        if (pageNumber > 0 && pageNumber <= Math.ceil(filteredEmployees.length / entriesToShow)) {
                          return (
                            <li key={pageNumber} className='page-item'>
                              <a href='#' className={`page-link ${pageNumber === currentPage ? 'active' : ''}`} onClick={() => changeCPage(pageNumber)}>{pageNumber}</a>
                            </li>
                          );
                        }
                        return null;
                      })}
                      <li className='page-item'>
                        <a href='#' className='page-link text-primary' onClick={nextPage}>Next</a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {selectedEmployee && (
        <Modal isOpen={modalOpen} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Employee Details</ModalHeader>
          <ModalBody>
            <div style={{ justifyContent: 'center', textAlign: 'center' }}>
              <img
                alt="Employee"
                className="rounded-circle"
                src={getImagePath(selectedEmployee.profile_image)}
                style={{ height: 100, marginBottom: 10 }}
                onError={e => { e.target.onerror = null; e.target.src = '/images/default-profile.png'; }}
              />
            </div>
            <div className="row">
              <div className="col-md-12">
                <div>
                  <label className='border p-2 rounded font-weight-bold' style={{width:'155px'}}>Employee ID</label>
                  <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                  <label className='border p-2 rounded '>{selectedEmployee.emp_id}</label>
                </div>
                <div>
                  <label className='border p-2 rounded font-weight-bold ' style={{width:'155px'}}>Name</label>
                  <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                  <label className='border p-2 rounded '>{selectedEmployee.emp_name}</label>
                </div>
                <div>
                  <label className='border p-2 rounded font-weight-bold ' style={{width:'155px'}}>Email</label>
                  <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                  <label className='border p-2 rounded '>{selectedEmployee.email}</label>
                </div>
                <div>
                  <label className='border p-2 rounded font-weight-bold ' style={{width:'155px'}}>Role</label>
                  <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                  <label className='border p-2 rounded '>{selectedEmployee.role}</label>
                </div>
                <div>
                  <label className='border p-2 rounded font-weight-bold ' style={{width:'155px'}}>Mobile Number </label>
                  <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                  <label className='border p-2 rounded '>{selectedEmployee.phoneno}</label>
                </div>
                <div>
                  <label className='border p-2 rounded font-weight-bold ' style={{width:'155px'}}>Date Of Joining</label>
                  <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                  <label className='border p-2 rounded '>{selectedEmployee.doj}</label>
                </div>
                <div>
                  <label className='border p-2 rounded font-weight-bold ' style={{width:'155px'}}>Salary</label>
                  <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                  <label className='border p-2 rounded '>{selectedEmployee.salary}</label>
                </div>
                <div>
                  <label className='border p-2 rounded font-weight-bold ' style={{width:'155px'}}>Address</label>
                  <label className=' p-2 rounded font-weight-bold m-1 '>:</label>
                  <label className='border p-2 rounded '>{selectedEmployee.address}</label>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default Employee1;
